import moneyIcon from '../../assets/icons/money.svg'
import soccerIcon from '../../assets/icons/soccer.svg'
import basketballIcon from '../../assets/icons/basketball.svg'
import rugbyIcon from '../../assets/icons/rugby.svg'
import badmintonIcon from '../../assets/icons/badminton.svg'
import cakeIcon from '../../assets/icons/cake.svg'
import cakeFullIcon from '../../assets/icons/cake_full.svg'
import coffeeIcon from '../../assets/icons/coffee.svg'
import diamondIcon from '../../assets/icons/diamond.svg'
import cloudRainIcon from '../../assets/icons/cloud_rain.svg'
import cloudHeavyIcon from '../../assets/icons/cloud_heavy.svg'
import cloudStormIcon from '../../assets/icons/cloud_storm.svg'
import phoneIcon from '../../assets/icons/phone.svg'
import mobileIcon from '../../assets/icons/mobile.svg'
import emailIcon from '../../assets/icons/email.svg'
import bulbOnIcon from '../../assets/icons/bulb_on.svg'
import diamondAlarmIcon from '../../assets/icons/diamond_alarm.png'
import diamondAdvisorIcon from '../../assets/icons/diamond_advisor.png'
import diamondReturnIcon from '../../assets/icons/diamond_return.png'
import diamondPlusIcon from '../../assets/icons/diamond_plus.png'
import diamondInfoIcon from '../../assets/icons/diamond_info.png'
import diamondPriceIcon from '../../assets/icons/diamond_price.png'
import rejectedIcon from '../../assets/icons/rejected.png'
import sercotecThinIcon from '../../assets/icons/sercotec_thin.svg'

const ICON_MAP = {
  money: moneyIcon,
  soccer: soccerIcon,
  basketball: basketballIcon,
  rugby: rugbyIcon,
  badminton: badmintonIcon,
  cake: cakeIcon,
  cake_full: cakeFullIcon,
  coffee: coffeeIcon,
  diamond: diamondIcon,
  diamond_blue: diamondIcon, // rendered as inline SVG, this is fallback
  diamond_alarm: diamondAlarmIcon,
  diamond_advisor: diamondAdvisorIcon,
  diamond_return: diamondReturnIcon,
  diamond_plus: diamondPlusIcon,
  diamond_info: diamondInfoIcon,
  diamond_price: diamondPriceIcon,
  rejected: rejectedIcon,
  sercotec_plus: null, // emoji inline
  sercotec: sercotecThinIcon,
  stopwatch: null, // emoji inline ⏱
  hourglass: null, // emoji inline ⏳
  cloud_rain: cloudRainIcon,
  cloud_heavy: cloudHeavyIcon,
  cloud_storm: cloudStormIcon,
  phone: phoneIcon,
  mobile: mobileIcon,
  whatsapp: null, // inline SVG
  email: emailIcon,
  bulb_on: bulbOnIcon,
  bulb_off: bulbOnIcon, // same SVG, dimmed via CSS
  publicidad_software: null,    // emoji inline 💻
  publicidad_kits: null,        // emoji inline 📦
  publicidad_bole: null,        // emoji inline 🧾
  publicidad_presupuesto: null, // emoji inline 💸
  publicidad_pelotas: null,    // emoji ⚽ + 📢
  publicidad_tortas: null,     // emoji 🎂 + 📢
  publicidad_diamantes: null,  // SVG diamante rojo + 📢
  publicidad_bombillas: null,  // emoji 💡 + 📢
  publicidad_sercotec: null,   // emoji ⭐ + 📢
  publicidad_frio: null,       // SVG diamante azul + 📢
}

// Map old numeric IDs from prospect_iconos table to new string IDs
const LEGACY_MAP = {
  1: 'diamond',
  2: 'bulb_on',
  3: 'bulb_off',
  4: 'coffee',
  5: 'coffee',
  6: 'phone',
  7: 'cloud_heavy',
  8: 'cloud_rain',
  9: 'cloud_storm',
  10: 'soccer',
  11: 'cake',
  30: 'cake_full',
  // String keys (DB may return "1" instead of 1)
  '1': 'diamond',
  '2': 'bulb_on',
  '3': 'bulb_off',
  '4': 'coffee',
  '5': 'coffee',
  '6': 'phone',
  '7': 'cloud_heavy',
  '8': 'cloud_rain',
  '9': 'cloud_storm',
  '10': 'soccer',
  '11': 'cake',
  '30': 'cake_full',
}

// Map DB nombre values to frontend string icon IDs
// icon_current now returns pi.nombre from DB
export const NOMBRE_MAP = {
  'diamante': 'diamond',
  'bombilla_on': 'bulb_on',
  'bombilla_off': 'bulb_off',
  'reloj_arena': 'coffee',
  'cafe': 'coffee',
  'despertador': 'phone',
  'lluvia': 'cloud_heavy',
  'nube': 'cloud_rain',
  'rayo': 'cloud_storm',
  'balon': 'soccer',
  'torta': 'cake',
  'torta_completa': 'cake_full',
  'cake_full': 'cake_full',
  'diamante_azul': 'diamond_blue',
  // New icons map to themselves (nombre === frontend id)
  'money': 'money',
  'soccer': 'soccer',
  'basketball': 'basketball',
  'rugby': 'rugby',
  'badminton': 'badminton',
  'cake': 'cake',
  'diamante_alarma': 'diamond_alarm',
  'diamante_asesor': 'diamond_advisor',
  'diamante_vuelve': 'diamond_return',
  'diamante_plus': 'diamond_plus',
  'diamante_info': 'diamond_info',
  'diamante_precio': 'diamond_price',
  'descartado': 'rejected',
  'diamond_alarm': 'diamond_alarm',
  'diamond_advisor': 'diamond_advisor',
  'diamond_return': 'diamond_return',
  'diamond_plus': 'diamond_plus',
  'diamond_info': 'diamond_info',
  'diamond_price': 'diamond_price',
  'rejected': 'rejected',
  'coffee': 'coffee',
  'diamond': 'diamond',
  'cloud_rain': 'cloud_rain',
  'cloud_heavy': 'cloud_heavy',
  'cloud_storm': 'cloud_storm',
  'phone': 'phone',
  'mobile': 'mobile',
  'whatsapp': 'whatsapp',
  'email': 'email',
  'bulb_on': 'bulb_on',
  'bulb_off': 'bulb_off',
  'sercotec_plus': 'sercotec_plus',
  'sercotec': 'sercotec',
  'stopwatch': 'stopwatch',
  'hourglass': 'hourglass',
  'publicidad_software':    'publicidad_software',
  'publicidad_kits':        'publicidad_kits',
  'publicidad_bole':        'publicidad_bole',
  'publicidad_presupuesto': 'publicidad_presupuesto',
  'publicidad_pelotas':    'publicidad_pelotas',
  'publicidad_tortas':     'publicidad_tortas',
  'publicidad_diamantes':  'publicidad_diamantes',
  'publicidad_bombillas':  'publicidad_bombillas',
  'publicidad_sercotec':   'publicidad_sercotec',
  'publicidad_frio':       'publicidad_frio',
}

const SIZES = {
  xs: 'w-4 h-4',
  sm: 'w-5 h-5',
  md: 'w-7 h-7',
  lg: 'w-9 h-9',
  table: 'w-6 h-6',
}

export const ICON_LIST = [
  { id: 'money', label: 'Dinero' },
  { id: 'soccer', label: 'Futbol' },
  { id: 'basketball', label: 'Basketball' },
  { id: 'rugby', label: 'Rugby' },
  { id: 'badminton', label: 'Badminton' },
  { id: 'sercotec_plus', label: 'SERCOTEC+' },
  { id: 'sercotec', label: 'SERCOTEC' },
  { id: 'cake_full', label: 'Torta Completa' },
  { id: 'cake', label: 'Trozo de Torta' },
  { id: 'coffee', label: 'Cafe' },
  { id: 'diamond', label: 'Diamante Rojo' },
  { id: 'diamond_blue', label: 'Diamante Azul' },
  { id: 'stopwatch', label: 'Cronómetro' },
  { id: 'hourglass', label: 'Reloj de Arena' },
  { id: 'cloud_rain', label: 'Nube lluvia' },
  { id: 'cloud_heavy', label: 'Lluvia fuerte' },
  { id: 'cloud_storm', label: 'Tormenta' },
  { id: 'phone', label: 'Telefono' },
  { id: 'mobile', label: 'Celular' },
  { id: 'whatsapp', label: 'WhatsApp' },
  { id: 'email', label: 'Correo' },
  { id: 'bulb_on', label: 'Bombilla encendida' },
  { id: 'bulb_off', label: 'Bombilla apagada' },
  { id: 'diamond_alarm', label: 'Diamante Alarma' },
  { id: 'diamond_advisor', label: 'Diamante Asesor' },
  { id: 'diamond_return', label: 'Diamante Vuelve' },
  { id: 'diamond_plus', label: 'Diamante Info+' },
  { id: 'diamond_info', label: 'Diamante Info' },
  { id: 'diamond_price', label: 'Diamante Precio' },
  { id: 'rejected', label: 'Descartado' },
  { id: 'publicidad_software',    label: 'Publicidad Software' },
  { id: 'publicidad_kits',        label: 'Publicidad Kits' },
  { id: 'publicidad_bole',        label: 'Publicidad Bol-E' },
  { id: 'publicidad_presupuesto', label: 'Publicidad por presupuesto' },
  { id: 'publicidad_pelotas',    label: 'Publicidad Pelotas' },
  { id: 'publicidad_tortas',     label: 'Publicidad de Tortas' },
  { id: 'publicidad_diamantes',  label: 'Publicidad de Diamantes' },
  { id: 'publicidad_bombillas',  label: 'Publicidad Bombillas' },
  { id: 'publicidad_sercotec',   label: 'Publicidad SERCOTEC' },
  { id: 'publicidad_frio',       label: 'Publicidad Frío' },
]

// Mapa id canonico -> label natural (derivado de ICON_LIST, unica fuente de labels)
const LABEL_MAP = Object.fromEntries(ICON_LIST.map(i => [i.id, i.label]))

/**
 * Devuelve el nombre natural de un icono a partir de cualquier identificador
 * (nombre tecnico de BD como "diamond_advisor", nombre legacy espanol como
 * "diamante_asesor", o id numerico legacy). Misma cadena de resolucion que
 * RatingIcon. Fallback: el identificador tal cual (mejor mostrar el tecnico
 * que un label equivocado si aparece un icono nuevo sin label).
 */
export function iconLabel(iconId) {
  const key = LEGACY_MAP[iconId] || NOMBRE_MAP[iconId] || iconId
  return LABEL_MAP[key] || String(iconId || '')
}

// ICON_ROWS: representa el layout visual del modal RatingIcon e IconFilterModal.
// Antes mantenia la invariante "flatten(ICON_ROWS) === ICON_PRIORITY", pero a partir
// de migration 029 (publicidad icons, 2026-05-05) las dos estructuras divergen:
// rejected (X) queda visualmente en row 5 con diamond_blue/clima por cohesion, pero
// en priority order queda DEBAJO del bloque publicidad (publicidad activa > dead lead).
// Si agregas nuevos iconos, decidi explicitamente si la invariante aplica o no.
export const ICON_ROWS = [
  [{ id: 'money', label: 'Dinero' }],
  [{ id: 'soccer', label: 'Futbol' }, { id: 'basketball', label: 'Basketball' }, { id: 'rugby', label: 'Rugby' }, { id: 'badminton', label: 'Badminton' }],
  [{ id: 'sercotec_plus', label: 'SERCOTEC+' }, { id: 'sercotec', label: 'SERCOTEC' }],
  [{ id: 'cake_full', label: 'Torta Completa' }, { id: 'cake', label: 'Trozo de Torta' }, { id: 'coffee', label: 'Cafe' }],
  [{ id: 'diamond_alarm', label: 'Alarma' }, { id: 'diamond_advisor', label: 'Asesor' }, { id: 'diamond_return', label: 'Vuelve' }, { id: 'diamond_plus', label: 'Info+' }, { id: 'diamond_info', label: 'Info' }, { id: 'diamond_price', label: 'Precio' }, { id: 'diamond', label: 'Diamante Rojo' }],
  [{ id: 'diamond_blue', label: 'Diamante Azul' }, { id: 'stopwatch', label: 'Cronómetro' }, { id: 'hourglass', label: 'Reloj de Arena' }, { id: 'cloud_rain', label: 'Nube lluvia' }, { id: 'cloud_heavy', label: 'Lluvia fuerte' }, { id: 'cloud_storm', label: 'Tormenta' }, { id: 'rejected', label: 'Descartado' }],
  [{ id: 'publicidad_software', label: 'Publicidad Software' }, { id: 'publicidad_kits', label: 'Publicidad Kits' }, { id: 'publicidad_bole', label: 'Publicidad Bol-E' }, { id: 'publicidad_presupuesto', label: 'Publicidad por presupuesto' }, { id: 'publicidad_pelotas', label: 'Publicidad Pelotas' }, { id: 'publicidad_sercotec', label: 'Publicidad SERCOTEC' }, { id: 'publicidad_tortas', label: 'Publicidad de Tortas' }, { id: 'publicidad_diamantes', label: 'Publicidad de Diamantes' }, { id: 'publicidad_frio', label: 'Publicidad Frío' }, { id: 'publicidad_bombillas', label: 'Publicidad Bombillas' }],
  [{ id: 'phone', label: 'Telefono' }, { id: 'mobile', label: 'Celular' }, { id: 'whatsapp', label: 'WhatsApp' }, { id: 'email', label: 'Correo' }],
  [{ id: 'bulb_on', label: 'Bombilla encendida' }, { id: 'bulb_off', label: 'Bombilla apagada' }],
]

function renderWithMegaphone(glyph, size, className = '') {
  const badgeSize = { xs: '0.65rem', sm: '0.8rem', md: '1.05rem', lg: '1.3rem', table: '0.85rem' }[size] || '1.05rem'
  return (
    <span className={`relative inline-flex items-center justify-center ${className}`}>
      <span className="absolute inset-0 rounded-lg" style={{ backgroundColor: 'rgba(249, 115, 22, 0.25)', margin: '-3px' }} aria-hidden="true" />
      <span className="relative inline-flex">{glyph}</span>
      <span
        className="absolute pointer-events-none"
        style={{ top: '-7px', right: '-8px', fontSize: badgeSize, lineHeight: 1, filter: 'drop-shadow(0 0 1px #fff) drop-shadow(0 0 1.5px #fff)' }}
      >&#x1F4E2;</span>
    </span>
  )
}

export default function RatingIcon({ iconId, size = 'md', className = '' }) {
  const sizeClass = SIZES[size] || SIZES.md
  const iconKey = LEGACY_MAP[iconId] || NOMBRE_MAP[iconId] || (ICON_MAP[iconId] ? iconId : null) || 'bulb_off'
  const src = ICON_MAP[iconKey]


  // Diamond: inline SVG (red)
  if (iconKey === 'diamond') {
    return (
      <svg className={`${sizeClass} ${className}`} viewBox="0 0 128 128" fill="none" xmlns="http://www.w3.org/2000/svg">
        <polygon points="64,8 120,48 64,120 8,48" fill="#D32F2F"/>
        <polygon points="64,8 120,48 92,48" fill="#E53935"/>
        <polygon points="64,8 36,48 8,48" fill="#C62828"/>
        <polygon points="64,8 36,48 92,48" fill="#EF5350"/>
        <polygon points="64,120 36,48 8,48" fill="#B71C1C"/>
        <polygon points="64,120 92,48 120,48" fill="#C62828"/>
        <polygon points="64,120 36,48 92,48" fill="#D32F2F"/>
        <polygon points="64,8 50,48 78,48" fill="#EF5350" opacity="0.4"/>
      </svg>
    )
  }

  // Blue Diamond: inline SVG
  if (iconKey === 'diamond_blue') {
    return (
      <svg className={`${sizeClass} ${className}`} viewBox="0 0 128 128" fill="none" xmlns="http://www.w3.org/2000/svg">
        <polygon points="64,8 120,48 64,120 8,48" fill="#1565C0"/>
        <polygon points="64,8 120,48 92,48" fill="#1E88E5"/>
        <polygon points="64,8 36,48 8,48" fill="#0D47A1"/>
        <polygon points="64,8 36,48 92,48" fill="#42A5F5"/>
        <polygon points="64,120 36,48 8,48" fill="#0D47A1"/>
        <polygon points="64,120 92,48 120,48" fill="#1565C0"/>
        <polygon points="64,120 36,48 92,48" fill="#1976D2"/>
        <polygon points="64,8 50,48 78,48" fill="#42A5F5" opacity="0.4"/>
      </svg>
    )
  }

  if (iconKey === 'whatsapp') {
    return (
      <svg className={`${sizeClass} ${className} text-green-500`} viewBox="0 0 24 24" fill="currentColor">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/>
        <path d="M12 2C6.486 2 2 6.486 2 12c0 1.86.507 3.6 1.389 5.09L2.07 21.78a.5.5 0 00.612.638l4.857-1.3A9.95 9.95 0 0012 22c5.514 0 10-4.486 10-10S17.514 2 12 2z"/>
      </svg>
    )
  }

  // sercotec_plus: emoji nativo ⭐ (U+2B50)
  if (iconKey === 'sercotec_plus') {
    const emojiSize = { xs: '1rem', sm: '1.25rem', md: '1.75rem', lg: '2.25rem', table: '1.5rem' }[size] || '1.75rem'
    return <span className={`${sizeClass} ${className} inline-flex items-center justify-center`} style={{ fontSize: emojiSize }}>&#x2B50;</span>
  }

  // publicidad_software: emoji nativo 💻 con sombreado para destacar del fondo
  if (iconKey === 'publicidad_software') {
    const emojiSize = { xs: '1rem', sm: '1.25rem', md: '1.75rem', lg: '2.25rem', table: '1.5rem' }[size] || '1.75rem'
    return (
      <span
        className={`${sizeClass} ${className} inline-flex items-center justify-center`}
        style={{
          fontSize: emojiSize,
          filter: 'drop-shadow(0 0 1px rgba(0,0,0,0.8)) drop-shadow(0 0 0.5px rgba(0,0,0,0.4))'
        }}
      >&#x1F4BB;</span>
    )
  }

  // publicidad_kits: emoji nativo 📦 con sombreado
  if (iconKey === 'publicidad_kits') {
    const emojiSize = { xs: '1rem', sm: '1.25rem', md: '1.75rem', lg: '2.25rem', table: '1.5rem' }[size] || '1.75rem'
    return (
      <span
        className={`${sizeClass} ${className} inline-flex items-center justify-center`}
        style={{
          fontSize: emojiSize,
          filter: 'drop-shadow(0 0 1px rgba(0,0,0,0.8)) drop-shadow(0 0 0.5px rgba(0,0,0,0.4))'
        }}
      >&#x1F4E6;</span>
    )
  }

  // publicidad_bole: emoji nativo 🧾 con sombreado (crítico — boleta es mayoría blanca)
  if (iconKey === 'publicidad_bole') {
    const emojiSize = { xs: '1rem', sm: '1.25rem', md: '1.75rem', lg: '2.25rem', table: '1.5rem' }[size] || '1.75rem'
    return (
      <span
        className={`${sizeClass} ${className} inline-flex items-center justify-center`}
        style={{
          fontSize: emojiSize,
          filter: 'drop-shadow(0 0 1px rgba(0,0,0,0.8)) drop-shadow(0 0 0.5px rgba(0,0,0,0.4))'
        }}
      >&#x1F9FE;</span>
    )
  }

  // publicidad_presupuesto: emoji nativo 💸 con sombreado
  if (iconKey === 'publicidad_presupuesto') {
    const emojiSize = { xs: '1rem', sm: '1.25rem', md: '1.75rem', lg: '2.25rem', table: '1.5rem' }[size] || '1.75rem'
    return (
      <span
        className={`${sizeClass} ${className} inline-flex items-center justify-center`}
        style={{
          fontSize: emojiSize,
          filter: 'drop-shadow(0 0 1px rgba(0,0,0,0.8)) drop-shadow(0 0 0.5px rgba(0,0,0,0.4))'
        }}
      >&#x1F4B8;</span>
    )
  }

  // publicidad_pelotas
  if (iconKey === 'publicidad_pelotas') {
    const emojiSize = { xs: '1rem', sm: '1.25rem', md: '1.75rem', lg: '2.25rem', table: '1.5rem' }[size] || '1.75rem'
    const glyph = <span className={sizeClass} style={{ fontSize: emojiSize, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', filter: 'drop-shadow(0 0 1px rgba(0,0,0,0.8)) drop-shadow(0 0 0.5px rgba(0,0,0,0.4))' }}>&#x26BD;</span>
    return renderWithMegaphone(glyph, size, className)
  }
  // publicidad_tortas
  if (iconKey === 'publicidad_tortas') {
    const emojiSize = { xs: '1rem', sm: '1.25rem', md: '1.75rem', lg: '2.25rem', table: '1.5rem' }[size] || '1.75rem'
    const glyph = <span className={sizeClass} style={{ fontSize: emojiSize, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', filter: 'drop-shadow(0 0 1px rgba(0,0,0,0.8)) drop-shadow(0 0 0.5px rgba(0,0,0,0.4))' }}>&#x1F382;</span>
    return renderWithMegaphone(glyph, size, className)
  }
  // publicidad_bombillas
  if (iconKey === 'publicidad_bombillas') {
    const emojiSize = { xs: '1rem', sm: '1.25rem', md: '1.75rem', lg: '2.25rem', table: '1.5rem' }[size] || '1.75rem'
    const glyph = <span className={sizeClass} style={{ fontSize: emojiSize, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', filter: 'drop-shadow(0 0 1px rgba(0,0,0,0.8)) drop-shadow(0 0 0.5px rgba(0,0,0,0.4))' }}>&#x1F4A1;</span>
    return renderWithMegaphone(glyph, size, className)
  }
  // publicidad_sercotec
  if (iconKey === 'publicidad_sercotec') {
    const emojiSize = { xs: '1rem', sm: '1.25rem', md: '1.75rem', lg: '2.25rem', table: '1.5rem' }[size] || '1.75rem'
    const glyph = <span className={sizeClass} style={{ fontSize: emojiSize, display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>&#x2B50;</span>
    return renderWithMegaphone(glyph, size, className)
  }
  // publicidad_diamantes
  if (iconKey === 'publicidad_diamantes') {
    const glyph = (
      <svg className={sizeClass} viewBox="0 0 128 128" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ filter: 'drop-shadow(0 0 1px rgba(0,0,0,0.6))' }}>
        <polygon points="64,8 120,48 64,120 8,48" fill="#D32F2F"/>
        <polygon points="64,8 120,48 92,48" fill="#E53935"/>
        <polygon points="64,8 36,48 8,48" fill="#C62828"/>
        <polygon points="64,8 36,48 92,48" fill="#EF5350"/>
        <polygon points="64,120 36,48 8,48" fill="#B71C1C"/>
        <polygon points="64,120 92,48 120,48" fill="#C62828"/>
        <polygon points="64,120 36,48 92,48" fill="#D32F2F"/>
        <polygon points="64,8 50,48 78,48" fill="#EF5350" opacity="0.4"/>
      </svg>
    )
    return renderWithMegaphone(glyph, size, className)
  }
  // publicidad_frio
  if (iconKey === 'publicidad_frio') {
    const glyph = (
      <svg className={sizeClass} viewBox="0 0 128 128" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ filter: 'drop-shadow(0 0 1px rgba(0,0,0,0.6))' }}>
        <polygon points="64,8 120,48 64,120 8,48" fill="#1565C0"/>
        <polygon points="64,8 120,48 92,48" fill="#1E88E5"/>
        <polygon points="64,8 36,48 8,48" fill="#0D47A1"/>
        <polygon points="64,8 36,48 92,48" fill="#42A5F5"/>
        <polygon points="64,120 36,48 8,48" fill="#0D47A1"/>
        <polygon points="64,120 92,48 120,48" fill="#1565C0"/>
        <polygon points="64,120 36,48 92,48" fill="#1976D2"/>
        <polygon points="64,8 50,48 78,48" fill="#42A5F5" opacity="0.4"/>
      </svg>
    )
    return renderWithMegaphone(glyph, size, className)
  }

  // Cake (trozo de torta): use native emoji instead of SVG
  if (iconKey === 'cake') {
    const emojiSize = { xs: '1rem', sm: '1.25rem', md: '1.75rem', lg: '2.25rem', table: '1.5rem' }[size] || '1.75rem'
    return <span className={`${sizeClass} ${className} inline-flex items-center justify-center`} style={{ fontSize: emojiSize }}>&#x1F370;</span>
  }

  // Stopwatch (cronómetro): emoji nativo ⏱ con sombreado para destacar del fondo
  if (iconKey === 'stopwatch') {
    const emojiSize = { xs: '1rem', sm: '1.25rem', md: '1.75rem', lg: '2.25rem', table: '1.5rem' }[size] || '1.75rem'
    return (
      <span
        className={`${sizeClass} ${className} inline-flex items-center justify-center`}
        style={{
          fontSize: emojiSize,
          filter: 'drop-shadow(0 0 1px rgba(0,0,0,0.8)) drop-shadow(0 0 0.5px rgba(0,0,0,0.4))'
        }}
      >&#x23F1;&#xFE0F;</span>
    )
  }

  // Hourglass (reloj de arena): emoji nativo ⏳ con sombreado
  if (iconKey === 'hourglass') {
    const emojiSize = { xs: '1rem', sm: '1.25rem', md: '1.75rem', lg: '2.25rem', table: '1.5rem' }[size] || '1.75rem'
    return (
      <span
        className={`${sizeClass} ${className} inline-flex items-center justify-center`}
        style={{
          fontSize: emojiSize,
          filter: 'drop-shadow(0 0 1px rgba(0,0,0,0.8)) drop-shadow(0 0 0.5px rgba(0,0,0,0.4))'
        }}
      >&#x23F3;</span>
    )
  }

  if (!src) {
    return <div className={`${sizeClass} ${className} rounded-full bg-gray-200 dark:bg-gray-700`} />
  }

  const isDimmed = iconKey === 'bulb_off'
  const isRed = iconKey === 'diamond'

  return (
    <img
      src={src}
      alt={iconKey}
      className={`${sizeClass} ${className} ${isDimmed ? 'opacity-30 grayscale' : ''}`}
      style={{ filter: 'drop-shadow(0 0 1px rgba(0,0,0,0.8)) drop-shadow(0 0 0.5px rgba(0,0,0,0.4))' }}
      draggable={false}
    />
  )
}

